import { useQuery } from "@tanstack/react-query";
import { queries } from "@core-shop/cache";

export function useBaseLink({ id = "" }) {
  return useQuery(queries.baseLink(id));
}
